const $$splitErrorComponentImporter = () => import('/home/ubuntu/actix-web-dome/ui/src/apps/main/routes/_main/user/app/$appId/sub-app/list.tsx?tsr-split=errorComponent');
const $$splitComponentImporter = () => import('/home/ubuntu/actix-web-dome/ui/src/apps/main/routes/_main/user/app/$appId/sub-app/list.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { SubAppListFilterParamSchema } from '@apps/main/features/user/pages/app/detail/sub-app/list-schema';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_main/user/app/$appId/sub-app/list')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: SubAppListFilterParamSchema,
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent')
});